import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Explanation, ExplanationHistory } from '@/types/explanation.types';

interface ExplanationSliceState {
  explanations: Explanation[];
  history: ExplanationHistory | null;
  activeExplanation: Explanation | null;
  loading: boolean;
  error: string | null;
}

const initialState: ExplanationSliceState = {
  explanations: [],
  history: null,
  activeExplanation: null,
  loading: false,
  error: null,
};

const explanationSlice = createSlice({
  name: 'explanation',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    addExplanation: (state, action: PayloadAction<Explanation>) => {
      state.explanations.unshift(action.payload);
      state.activeExplanation = action.payload;
    },
    setHistory: (state, action: PayloadAction<ExplanationHistory>) => {
      state.history = action.payload;
    },
    setActiveExplanation: (state, action: PayloadAction<Explanation | null>) => {
      state.activeExplanation = action.payload;
    },
    clearExplanations: (state) => {
      state.explanations = [];
      state.activeExplanation = null;
    },
  },
});

export const {
  setLoading,
  setError,
  addExplanation,
  setHistory,
  setActiveExplanation,
  clearExplanations,
} = explanationSlice.actions;

export default explanationSlice.reducer;
